module.exports = __webpack_public_path__ + "static/media/Nikki-Travis.097699d8.jpg";